function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, "@keyframes slide{0%{transform:translateX(-150px)}to{transform:translateX(150px)}}@keyframes show{0%{transform:scale(0)}to{transform:scale(1)}}@keyframes scale{0%{opacity:0;transform:scale(0)}70%{opacity:1;transform:scale(1.1)}to{opacity:1;transform:scale(1)}}.CUA_svg__st0{fill:#c1272d}.CUA_svg__st2{fill:#eaeaea}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "CUA_svg__st2",
  d: "M0 0h200v150H0z"
});

function SvgCua(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 150"
  }, props), _ref, /*#__PURE__*/React.createElement("g", {
    id: "CUA_svg__logo"
  }, _ref2, /*#__PURE__*/React.createElement("path", {
    className: "CUA_svg__st0",
    d: "M60.3 112.1l4.9 6.4c.9 1.2.7 2.9-.5 3.8-6.2 5-12.6 7.3-20.4 7.3-17.8 0-29.4-11.1-29.4-32.3 0-25.1 15.6-33.4 29.9-33.4 7.7 0 15.4 3.1 21.3 10.8.9 1.2.7 3-.5 3.9L59 83.4c-1.9 1.3-3.5 1.2-4.4.1-3.2-3.9-6.6-5.9-10.6-5.9-7.2 0-12.2 6.3-12.2 18.8 0 12 4.1 19.8 13.4 19.8 4 0 7.8-1.7 11.3-4.5 1.2-1 2.9-.8 3.8.4z",
    style: {
      transformOrigin: "50px 100px",
      animationDelay: "0s",
      animationName: "scale",
      animationTimingFunction: "easeOutCubic",
      animationDuration: ".3s",
      animationFillMode: "forwards"
    },
    transform: "scale(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CUA_svg__st0",
    d: "M86.8 65c1.5 0 2.7 1.2 2.7 2.7v38.8c0 7.2 3.7 9.4 9 9.4 5 0 8.5-3 8.5-9V67.8c0-1.5 1.2-2.7 2.7-2.7h10.9c1.5 0 2.7 1.2 2.7 2.7v41.1c0 12.9-10.3 20.7-25.3 20.7-16.5 0-25-6.7-25-22.1V67.8c0-1.5 1.2-2.7 2.7-2.7h11.1z",
    style: {
      transformOrigin: "100px 100px",
      animationDelay: ".2s",
      animationName: "scale",
      animationTimingFunction: "easeOutCubic",
      animationDuration: ".3s",
      animationFillMode: "forwards"
    },
    transform: "scale(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.4 124.9l18.8-58c.4-1.1 1.4-1.9 2.6-1.9h14.5c1.2 0 2.2.7 2.6 1.8l20 58c.6 1.8-.7 3.6-2.6 3.6h-11.6c-1.2 0-2.2-.8-2.6-1.9l-3.7-11.6h-19.2l-3.7 11.6c-.4 1.1-1.4 1.9-2.6 1.9h-10c-1.7.1-3.1-1.7-2.5-3.5zm21.6-22h13.4L157 80.3h-.4l-6.6 22.6z",
    style: {
      transformOrigin: "150px 100px",
      animationDelay: ".4s",
      animationName: "scale",
      animationTimingFunction: "easeOutCubic",
      animationDuration: ".3s",
      animationFillMode: "forwards"
    },
    transform: "scale(0)",
    fill: "#0071bc"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CUA_svg__st0",
    d: "M158.9 55.5c-37.9-31.9-86-31.9-123.9 0-1.1 1-2.8.9-3.8-.3l-5-5.7c-1-1.1-.9-2.9.3-3.9 43.1-36.4 97.9-36.4 141 0 1.2 1 1.3 2.8.3 3.9l-5 5.7c-1.1 1.1-2.8 1.2-3.9.3z",
    style: {
      transformOrigin: "100px 20px",
      animationDelay: "1.8s",
      animationName: "show",
      animationDuration: "0s",
      animationFillMode: "forwards"
    },
    transform: "scale(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "CUA_svg__st2",
    style: {
      animation: "slide 2.4s .6s infinite linear"
    },
    d: "M20 10h150v50H20z"
  })));
}

export default SvgCua;